import React from "react";
import { Link } from "@remix-run/react"; // Use Link instead of NavLink for search params
import { cn } from "~/lib/utils";

interface AuthFooterProps {
  className?: string;
}

export default function AuthFooter({ className }: AuthFooterProps) {
  return (
    <footer className={cn("w-full py-2 px-2 text-sm", className)}>
      <div className="container mx-auto flex flex-wrap justify-center gap-x-6 gap-y-2">
        <Link
          to="/?view=privacy"
          className="hover:underline text-gray-200 hover:text-white bg-transparent border-none cursor-pointer p-0"
        >
          Privacy Policy
        </Link>
        <Link
          to="/?view=terms"
          className="hover:underline text-gray-200 hover:text-white bg-transparent border-none cursor-pointer p-0"
        >
          Terms & Conditions
        </Link>
        <Link
          to="/?view=terms" // Link Refund & Cancellation to Terms for now
          className="hover:underline text-gray-200 hover:text-white bg-transparent border-none cursor-pointer p-0"
        >
          Refund & Cancellation Policy
        </Link>
        <Link
          to="/?view=contact"
          className="hover:underline text-gray-200 hover:text-white bg-transparent border-none cursor-pointer p-0"
        >
          Contact Us
        </Link>
        <Link
          to="/?view=about-us"
          className="hover:underline text-gray-200 hover:text-white bg-transparent border-none cursor-pointer p-0"
        >
          About Us
        </Link>
      </div>
      <div className="text-center mt-4 text-xs text-gray-400">
        © {new Date().getFullYear()} FlirtyBum. All rights reserved.
      </div>
    </footer>
  );
}
